function preferredColorScheme() {
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    return prefersDark ? "dark" /*                  */ : "light" /*                   */;
}
function preferredContrast() {
    if (window.matchMedia("(prefers-contrast: more)").matches) {
        return "more" /*                    */;
    }
    if (window.matchMedia("(prefers-contrast: less)").matches) {
        return "less" /*                    */;
    }
    if (window.matchMedia("(prefers-contrast: custom)").matches) {
        return "custom" /*                      */;
    }
    return null;
}

function enrichPageImpression() {
    const pageImpression = {
        ot_PreferredColorScheme: preferredColorScheme(),
    };
    const contrastLevel = preferredContrast();
    if (contrastLevel) {
        pageImpression.ot_PreferredContrast = contrastLevel;
    }
    window.o_global.eventQBus.emit("tracking.bct.addToPageImpression", pageImpression);
}

/*                 */
const findInUserAgent = window.o_util?.browser?.findInUserAgent;

var Browser;
(function (Browser) {
    Browser["SILK"] = "Silk";
    Browser["ICEWEASEL"] = "Iceweasel";
    Browser["NOKIA"] = "BrowserNG/NokiaBrowser";
    Browser["OTHER"] = "other";
    Browser["UNKNOWN"] = "unknown";
    Browser["EDGE"] = "Edge";
    Browser["CHROME"] = "Chrome";
    Browser["MOBILE_SAFARI"] = "Mobile Safari";
    Browser["SAFARI"] = "Safari";
    Browser["FIREFOX"] = "Firefox";
    Browser["OPERA"] = "Opera";
    Browser["OPERA_MOBILE"] = "Opera Mobile";
    Browser["OPERA_MINI"] = "Opera Mini";
    Browser["MSIE"] = "MSIE (not supported Version)";
    Browser["MSIE9"] = "MSIE9";
    Browser["MSIE10"] = "MSIE10";
    Browser["MSIE11"] = "MSIE11";
})(Browser || (Browser = {}));
/**
 *
 *
 *
 *
 */
function browser() {
    if (!findInUserAgent) {
        return Browser.UNKNOWN;
    }
    /*                    */
    if (findInUserAgent("silk")) {
        return Browser.SILK;
    }
    /*        */
    if (findInUserAgent("iceweasel")) {
        return Browser.ICEWEASEL;
    }
    /*           */
    if (findInUserAgent("nokiabrowser") || findInUserAgent("browserng")) {
        return Browser.NOKIA;
    }
    /*                                */
    if (findInUserAgent("edg")) {
        return Browser.EDGE;
    }
    /*                   */
    if ((findInUserAgent("crios") || findInUserAgent("chrome")) &&
        !findInUserAgent("opera") &&
        !findInUserAgent("opr/")) {
        return Browser.CHROME;
    }
    /*                                           */
    if (findInUserAgent("safari") &&
        findInUserAgent("mobile") &&
        !findInUserAgent("chrome") &&
        !findInUserAgent("crios") &&
        !findInUserAgent("silk")) {
        return Browser.MOBILE_SAFARI;
    }
    /*     */
    if (findInUserAgent("safari") &&
        !findInUserAgent("chrome") &&
        !findInUserAgent("crios") &&
        !findInUserAgent("silk")) {
        return Browser.SAFARI;
    }
    /*      */
    if (findInUserAgent("firefox") && !findInUserAgent("seamonkey")) {
        return Browser.FIREFOX;
    }
    /*            */
    /*                */
    if (findInUserAgent("msie 9")) {
        return Browser.MSIE9;
    }
    if (findInUserAgent("msie 10")) {
        return Browser.MSIE10;
    }
    if (findInUserAgent("msie 11") ||
        findInUserAgent("rv:11.0") ||
        findInUserAgent("compatible; MSIE 8.0; Windows NT 6.1; Trident/4.0; Tablet PC 2.0") ||
        findInUserAgent("compatible; MSIE 7.0; Windows NT 6.3; Trident/7.0; Touch")) {
        return Browser.MSIE11;
    }
    if (findInUserAgent("msie")) {
        return Browser.MSIE;
    }
    /*         */
    if (findInUserAgent("opera mini")) {
        return Browser.OPERA_MINI;
    }
    /*    */
    if (findInUserAgent("opera") || findInUserAgent("presto") || findInUserAgent("opr/")) {
        /*           */
        if (findInUserAgent("mobi")) {
            return Browser.OPERA_MOBILE;
        }
        return Browser.OPERA;
    }
    /**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
    return Browser.OTHER;
}

const EVENTS = {
    hybridDetected: "assets.device.hybrid.detected",
    touchableDetected: "assets.device.touchable.detected",
    orientationChanged: "assets.device.orientation.changed",
};
const events = window.o_global.events();

const GlobalEventLoader = window.o_global?.eventLoader;

const GlobalStorage = window.o_global?.Storage;

function executeCallback(callback, ...payload) {
    Promise.resolve(payload).then((p) => callback(...p));
}

const eventName = "mousemove";
const storageKey = "isHybrid";
/*                                                                                                   */
const minMovesForSuccess = 3;
/*                                                                                 */
const maxTimeForSuccess = 300;
/*                                                                          */
const mayAttemptsForSuccess = 8;
function markHybrid(instance, data) {
    instance.isHybrid = true;
    events.emitRetain("assets.device.hybrid.detected", data);
    document.documentElement.classList.add("touchable-hybrid");
    return instance;
}
/*                                */
class Hybrid {
    constructor() {
        this.storage = new GlobalStorage(() => window.sessionStorage);
        /*                                                                                     */
        this.mouseMoveCounter = 0;
        /*                                                                      */
        this.checkCounter = 0;
        /*                                                                                        */
        this.timeoutIdArr = [];
        /*                                               */
        this.isHybrid = false;
        /*                       */
        this.callbacks = [];
        /*                               */
        this.document = document.documentElement;
        /*                                                   */
        this.executeOrRegisterCallback = this.onHybridDetected;
        /*                                     */
        this.checkMouseMoves = () => {
            this.mouseMoveCounter += 1;
            if (this.mouseMoveCounter > minMovesForSuccess) {
                this.cleanup();
                /*                     */
                markHybrid(this, { fromDetector: true });
                /*                                   */
                this.storage.setItem(storageKey, "true");
                /*                        */
                this.callbacks.forEach(executeCallback);
            }
            /*                                             */
            if (this.isHybrid) {
                /*                                */
                return;
            }
            /*                       */
            /*                                      */
            /*                                       */
            const timeoutId = setTimeout(() => {
                /*                                                                 */
                this.mouseMoveCounter -= 1;
                this.checkCounter += 1;
                if (this.checkCounter > mayAttemptsForSuccess) {
                    this.cleanup();
                    this.storage.setItem(storageKey, "false");
                }
            }, 
            /*                                              */
            maxTimeForSuccess);
            this.timeoutIdArr.push(timeoutId);
        };
    }
    /*                                           */
    get isDetected() {
        return this.isHybrid;
    }
    /*                                                       */
    detect() {
        if (!window.o_global.device.isTouchable) {
            /*                                              */
            return this;
        }
        if (this.storage.getItem(storageKey) === "true") {
            /*                                              */
            return markHybrid(this, { fromStorage: true });
        }
        if (!this.storage.getItem(storageKey)) {
            /*                                                                          */
            GlobalEventLoader.onAllJavascriptLoaded(200, () => 
            /*                                                                               */
            executeCallback(() => this.document.addEventListener(eventName, this.checkMouseMoves)));
        }
        return this;
    }
    /**
 *
 *
 *
 *
 *
 */
    onHybridDetected(callback) {
        if (this.isHybrid) {
            executeCallback(callback);
            return;
        }
        this.callbacks.push(callback);
    }
    cleanup() {
        this.timeoutIdArr.filter(Boolean).forEach(clearTimeout);
        this.document.removeEventListener(eventName, this.checkMouseMoves);
    }
}
/**
 *
 *
 */
function hybrid() {
    return new Hybrid().detect();
}

var OrientationType;
(function (OrientationType) {
    OrientationType["PORTRAIT"] = "portrait";
    OrientationType["LANDSCAPE"] = "landscape";
    OrientationType["UNKNOWN"] = "unknown";
})(OrientationType || (OrientationType = {}));
class Orientation {
    constructor() {
        this.callbacks = [];
        this.orientation = {
            /*                                     */
            portrait: window.matchMedia(`(orientation: ${OrientationType.PORTRAIT})`),
            /*                                     */
            landscape: window.matchMedia(`(orientation: ${OrientationType.LANDSCAPE})`),
        };
        /*                                                       */
        this.registerChangeListener = this.onOrientationChanged;
        this.initializeOrientationListeners();
    }
    getCurrentOrientation() {
        if (this.isPortrait()) {
            return OrientationType.PORTRAIT;
        }
        if (this.isLandscape()) {
            return OrientationType.LANDSCAPE;
        }
        return OrientationType.UNKNOWN;
    }
    /**
 *
 *
 *
 *
 *
 */
    onOrientationChanged(callback) {
        this.callbacks.push(callback);
        return this;
    }
    trigger(mql) {
        /*                                                       */
        /*                                                 */
        /*                                                    */
        /*                                                                              */
        if (mql.matches) {
            /*                                                         */
            const currentOrientation = this.getCurrentOrientation();
            this.callbacks.forEach((cb) => {
                executeCallback(cb, currentOrientation);
            });
            events.emit(EVENTS.orientationChanged, currentOrientation);
        }
    }
    /*                                  */
    initializeOrientationListeners() {
        /*                                               */
        /*                                                                                  */
        /*                                                       */
        this.orientation.portrait.addListener((e) => this.trigger(e));
        this.orientation.landscape.addListener((e) => this.trigger(e));
        return this;
    }
    isPortrait() {
        return this.orientation.portrait.matches;
    }
    /**
 *
 *
 *
 *
 */
    isLandscape() {
        return this.orientation.landscape.matches;
    }
}
/**
 *
 *
 */
function orientation() {
    return new Orientation();
}

var OsType;
(function (OsType) {
    OsType["Window98"] = "Windows 98";
    OsType["WindowsMe"] = "Windows Me";
    OsType["NT"] = "Microsoft Windows NT 4.0";
    OsType["Windows2000"] = "Windows 2000";
    OsType["Windows2000SP1"] = "Windows 2000 SP1";
    OsType["WindowsXP"] = "Windows XP";
    OsType["Windows2003"] = "Windows Server 2003; Windows XP x64 Edition";
    OsType["WindowsVista"] = "Windows Vista";
    OsType["Windows7"] = "Windows7";
    OsType["Windows8"] = "Windows 8";
    OsType["Windows81"] = "Windows 8.1";
    OsType["Windows10"] = "Windows 10";
    OsType["Windows101"] = "Windows 10.1";
    OsType["Blackberry"] = "Blackberry";
    OsType["HpWebOs"] = "HP webOS";
    OsType["AmazonFireOs"] = "Amazon FireOS";
    OsType["Symbian"] = "Symbian";
    OsType["MacOs"] = "Mac OS";
    OsType["Linux"] = "Linux";
    OsType["WindowsPhone10"] = "Windows Phone 10.0";
    OsType["WindowsPhone"] = "Windows Phone";
    OsType["FirefoxOS"] = "Firefox OS";
    OsType["Android"] = "Android";
    OsType["Ios"] = "iOS";
    OsType["other"] = "other";
    OsType["UNKNOWN"] = "unknown";
})(OsType || (OsType = {}));
/**
 *
 *
 *
 *
 */
function os() {
    /*                                                                            */
    if (!findInUserAgent) {
        return OsType.UNKNOWN;
    }
    const windowsPlatformToken = {
        "Windows 98": OsType.Window98,
        "Windows 98; Win 9x 4.90 ": OsType.WindowsMe,
        "Windows NT 4.0": OsType.NT,
        "Windows NT 5.0": OsType.Windows2000,
        "Windows NT 5.01": OsType.Windows2000SP1,
        "Windows NT 5.1": OsType.WindowsXP,
        "Windows NT 5.2": OsType.Windows2003,
        "Windows NT 6.0": OsType.WindowsVista,
        "Windows NT 6.1": OsType.Windows7,
        "Windows NT 6.2": OsType.Windows8,
        "Windows NT 6.3": OsType.Windows81,
        "Windows NT 10.0": OsType.Windows10,
        "Windows NT 10.1": OsType.Windows101,
    };
    /*                                                                                    */
    /*                                              */
    const windows = Object.entries(windowsPlatformToken).filter(([key]) => {
        return findInUserAgent(key.toLowerCase());
    })[0];
    if (windows) {
        const [, value] = windows;
        return value;
    }
    /*           */
    const blackberryOS = ["blackberry", "bb10", "rim", "playbook"];
    if (blackberryOS.some(findInUserAgent)) {
        return OsType.Blackberry;
    }
    /*       */
    const webOs = ["webos", "hpwos"];
    if (webOs.some(findInUserAgent)) {
        return OsType.HpWebOs;
    }
    /*                                                                                    */
    const fireOS = ["silk", "kfot", "kftt", "kfjw", "kfsowi", "kfthw", "kfapw"];
    if (fireOS.some(findInUserAgent)) {
        return OsType.AmazonFireOs;
    }
    /*      */
    if (findInUserAgent("symbianos")) {
        return OsType.Symbian;
    }
    /*    */
    if (findInUserAgent("macintosh") && findInUserAgent("mac os x")) {
        return OsType.MacOs;
    }
    /*    */
    if (findInUserAgent("linux") && !findInUserAgent("android") && !findInUserAgent("webos")) {
        return OsType.Linux;
    }
    /*                 */
    if (findInUserAgent("windows phone 10.0")) {
        return OsType.WindowsPhone10;
    }
    /*            */
    if (findInUserAgent("windows phone")) {
        return OsType.WindowsPhone;
    }
    /*                                                                                 */
    const firefoxOS = ["(mobile;", "(tablet;"];
    if (firefoxOS.some(findInUserAgent)) {
        return OsType.FirefoxOS;
    }
    /*                                                            */
    if (findInUserAgent("android")) {
        return OsType.Android;
    }
    /*  */
    const ios = ["iphone", "ipad", "ipod"];
    if (ios.some(findInUserAgent)) {
        return OsType.Ios;
    }
    return OsType.other;
}

/**
 *
 */
const screen = {
    /*                               */
    getWidth: () => window.innerWidth,
    /*                                */
    getHeight: () => window.screen.height,
};

/**
 *
 *
 *
 *
 *
 *
 */
function isTouchable() {
    const data = {
        ontouchstart: "ontouchstart" in window,
        documentTouch: !!(window.DocumentTouch && document instanceof window.DocumentTouch),
        /*                                     */
        maxTouchPoints: !!window.navigator.maxTouchPoints,
    };
    const isTouchableFlag = data.ontouchstart || data.documentTouch || data.maxTouchPoints;
    if (isTouchableFlag) {
        /*                                                                        */
        document.documentElement.classList.add("touchable");
        /*                   */
        events.emitRetain(EVENTS.touchableDetected, data);
    }
    else {
        document.documentElement.classList.add("not-touchable");
    }
    return isTouchableFlag;
}

var DeviceType;
(function (DeviceType) {
    DeviceType["MOBILE"] = "mobile";
    DeviceType["DESKTOP"] = "desktop";
    DeviceType["TABLET"] = "tablet";
    DeviceType["UNKOWN"] = "unknown";
})(DeviceType || (DeviceType = {}));
/**
 *
 *
 *
 *
 */
function type() {
    if (!findInUserAgent) {
        return DeviceType.UNKOWN;
    }
    /*             */
    if ((findInUserAgent("mobile") && !findInUserAgent("ipad")) ||
        findInUserAgent("(mobile;") ||
        findInUserAgent("phone") ||
        (findInUserAgent("android") && findInUserAgent("mobile") && !findInUserAgent("ipad")) ||
        findInUserAgent("ipod") ||
        findInUserAgent("iphone") ||
        (findInUserAgent("windows") && findInUserAgent("phone")) ||
        (findInUserAgent("silk") && findInUserAgent("mobile")) ||
        findInUserAgent("symbianos") ||
        findInUserAgent("(mobile;")) {
        return DeviceType.MOBILE;
    }
    /*             */
    if (findInUserAgent("playbook") ||
        findInUserAgent("tablet") ||
        findInUserAgent("(tablet;") ||
        findInUserAgent("touch") ||
        (findInUserAgent("android") && !findInUserAgent("mobile")) ||
        findInUserAgent("ipad") ||
        (findInUserAgent("windows") && !findInUserAgent("phone") && findInUserAgent("touch")) ||
        (findInUserAgent("silk") && !findInUserAgent("mobile")) ||
        findInUserAgent("(tablet;")) {
        return DeviceType.TABLET;
    }
    /*         */
    if (findInUserAgent("blackberry") || findInUserAgent("bb10") || findInUserAgent("rim")) {
        return DeviceType.MOBILE;
    }
    return DeviceType.DESKTOP;
}

/*                                                                          */
if (window.o_util?.toggle?.get("ASSETS_device_preferences", false)) {
    enrichPageImpression();
}

export { Browser, DeviceType, EVENTS, Hybrid, Orientation, OrientationType, OsType, browser, events, hybrid, isTouchable, orientation, os, preferredColorScheme, preferredContrast, screen, type };
